export default {
    componentDidMount() {
        window.addEventListener("scroll", this.onScroll, false);
    },
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll, false);
    }
};



/** WEBPACK FOOTER **
 ** ./app/utils/mixins/onScroll.js
 **/